import script from "./BomCartSuggestions.vue?vue&type=script&setup=true&lang=ts"
export * from "./BomCartSuggestions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__